<table class="table table-striped" data-test="lbgReportEnergyConsumptionTable">
  <thead>
    <tr>
      <th style="width: 22%">{{ 'lbgPortfolioRoadmapReport.energyConsumption.address' | translate }}</th>
      <th class="text-end" style="width: 12%">
        {{ 'lbgPortfolioRoadmapReport.energyConsumption.electricityConsumption' | translate }}
      </th>
      <th class="text-end" style="width: 10%">
        {{ 'lbgPortfolioRoadmapReport.energyConsumption.gasConsumption' | translate }}
      </th>
      <th class="text-end" style="width: 10%">
        {{ 'lbgPortfolioRoadmapReport.energyConsumption.heatConsumption' | translate }}
      </th>
      <th class="text-end" style="width: 11%">
        {{ 'lbgPortfolioRoadmapReport.energyConsumption.energyIntensity' | translate }}
      </th>
      <th class="text-end" style="width: 9%">
        {{ 'lbgPortfolioRoadmapReport.energyConsumption.energyCosts' | translate }}
      </th>
      <th class="text-end" style="width: 10%">
        {{ 'lbgPortfolioRoadmapReport.energyConsumption.co2Emissions' | translate }}
      </th>
      <th class="text-end" style="width: 10%">
        {{ 'lbgPortfolioRoadmapReport.energyConsumption.co2Intensity' | translate }}
      </th>
      <th style="width: 6%">{{ 'lbgPortfolioRoadmapReport.energyConsumption.year' | translate }}</th>
    </tr>
  </thead>
  <tbody>
    @for (building of buildings(); track building.id) {
      @let energy = building.energyConsumption;
      <tr>
        <td>
          <div class="d-flex align-items-start">
            <cfp-street-view-image
              class="d-flex align-items-center flex-shrink-0"
              [buildingId]="building.id"
              [address]="building.displayAddress"
              [size]="'sm'"
              [showMonumentIcon]="building.monument"
            />
            <div
              class="ms-3 mb-0"
              [buildingAddress]="building.displayAddress"
              [countryCode]="building.countryCode"
            ></div>
          </div>
        </td>
        <td class="text-end text-nowrap">
          @if (energy) {
            <span class="d-inline-flex align-items-center justify-content-end gap-1">
              <span>{{ energy.totalElectricityConsumptionKwh | number: '1.0-0' }} kWh</span>
              @if (energy.electricityConsumptionIsBenchmark) {
                <cfp-icon [icon]="'search'" [iconStyle]="'success'" [classes]="'benchmark-icon'" />
              }
            </span>
          } @else {
            -
          }
        </td>
        <td class="text-end text-nowrap">
          @if (energy && energy.totalGasConsumptionM3 != null) {
            <span class="d-inline-flex align-items-center justify-content-end gap-1">
              <span>{{ energy.totalGasConsumptionM3 | number: '1.0-0' }} m<sup>3</sup></span>
              @if (energy.gasConsumptionIsBenchmark) {
                <cfp-icon [icon]="'search'" [iconStyle]="'success'" [classes]="'benchmark-icon'" />
              }
            </span>
          } @else {
            -
          }
        </td>
        <td class="text-end text-nowrap">
          @if (energy && energy.totalHeatConsumptionGj != null) {
            <span class="d-inline-flex align-items-center justify-content-end gap-1">
              <span>{{ energy.totalHeatConsumptionGj | number: '1.0-0' }} GJ</span>
              @if (energy.heatConsumptionIsBenchmark) {
                <cfp-icon [icon]="'search'" [iconStyle]="'success'" [classes]="'benchmark-icon'" />
              }
            </span>
          } @else {
            -
          }
        </td>
        <td class="text-end text-nowrap">
          @if (energy && energy.energyIntensityKwhM2 != null) {
            {{ energy.energyIntensityKwhM2 | number: '1.0-0' }} kWh/m<sup>2</sup>
          } @else {
            -
          }
        </td>
        <td class="text-end text-nowrap">
          @if (energy) {
            {{ energy.totalEnergyCosts | cfpCurrency: currencyCode() }}
          } @else {
            -
          }
        </td>
        <td class="text-end text-nowrap">
          @if (energy) {
            {{ energy.totalCo2ConsumptionTons | number: '1.0-0' }}
            {{ 'lbgPortfolioRoadmapReport.energyConsumption.tonnes' | translate }}
          } @else {
            -
          }
        </td>
        <td class="text-end text-nowrap">
          @if (energy) {
            {{ energy.co2IntensityKgM2 | number: '1.0-0' }} kg/m<sup>2</sup>
          } @else {
            -
          }
        </td>
        <td class="text-nowrap">
          @if (energy && energy.year != null) {
            {{ energy.year }}
          }
        </td>
      </tr>
    }
  </tbody>
  @if (showTotals()) {
    @let totalsValue = totals();
    @if (totalsValue) {
      <tfoot>
        <tr>
          <th>{{ 'lbgPortfolioRoadmapReport.energyConsumption.total' | translate }}</th>
          <th class="text-end text-nowrap">
            {{ totalsValue.totalElectricityConsumptionKwh | number: '1.0-0' }} kWh
          </th>
          <th class="text-end text-nowrap">
            @if (totalsValue.totalGasConsumptionM3 != null) {
              {{ totalsValue.totalGasConsumptionM3 | number: '1.0-0' }} m<sup>3</sup>
            } @else {
              -
            }
          </th>
          <th class="text-end text-nowrap">
            @if (totalsValue.totalHeatConsumptionGj != null) {
              {{ totalsValue.totalHeatConsumptionGj | number: '1.0-0' }} GJ
            } @else {
              -
            }
          </th>
          <th></th>
          <th class="text-end text-nowrap">
            {{ totalsValue.totalEnergyCosts | cfpCurrency: currencyCode() }}
          </th>
          <th class="text-end text-nowrap">
            {{ totalsValue.totalCo2ConsumptionTons | number: '1.0-0' }}
            {{ 'lbgPortfolioRoadmapReport.energyConsumption.tonnes' | translate }}
          </th>
          <th></th>
          <th></th>
        </tr>
      </tfoot>
    }
  }
</table>
